export default __webpack_public_path__ + "static/media/green-circle.4547f79b.svg";